export const templateFn = function anonymous(locals, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<span class=\"nb-container\" new-nginbar>\n  <span class=\"nb-main <%= $ctrl.nbMainClass %>\">\n\n    <%- $ctrl.backButton %>\n\n    <%# SE Logo / Mobile Menu %>\n    <a <%- $ctrl.trackElementAs('$seLogo') %> href=\"<%= $ctrl.appHomeUrl %>\" target=\"_top\" class=\"<%= $ctrl.logoClass %>\"><%= $ctrl.appName %></a>\n    <% if ($ctrl.hasMobileNav) { %>\n      <button aria-label=\"<%= t('NAVIGATION.label')%>\" <%- $ctrl.trackElementAs('$mobileTrigger') %>class=\"nb-sportngin--mobile nb-sportngin--mobile-with-nav\">\n        <%- $ctrl.mobileNavIcon %>\n        <span class=\"nb-mobile-nav__label\"><%= t('menu') %></span>\n      </button>\n    <% } else { %>\n      <a href=\"<%= $ctrl.config.urls.se %>\" alt=\"<%= t('sportsengine_alt') %>\" class=\"nb-sportngin--mobile\"><%= t('sportsengine') %></a>\n    <% } %>\n\n    <span class=\"nb-search__container\" <%- $ctrl.trackElementAs('searchContainer') %>></span>\n\n    <% if ($ctrl.profile) { %>\n      <%- $ctrl.switcherButton %>\n    <% } %>\n\n    <%# Chat %>\n    <% if ($ctrl.profile) { %>\n      <%- $ctrl.chatButton %>\n    <% } %>\n\n    <%# Messages %>\n    <% if ($ctrl.profile) { %>\n      <%- $ctrl.messagesButton %>\n    <% } %>\n\n    <%# Notifications %>\n    <% if ($ctrl.profile) { %>\n      <%- $ctrl.notificationsButton %>\n    <% } %>\n\n    <%# User / Sign In %>\n    <% if ($ctrl.profile) { %>\n      <%- $ctrl.profileButton %>\n    <% } else { %>\n      <%- $ctrl.signInButton %>\n    <% } %>\n  </span>\n</span>\n\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
$ctrl = __locals.$ctrl,
  config = __locals.config,
  formatDate = __locals.formatDate,
  hasTouch = __locals.hasTouch,
  initializeCSSVars = __locals.initializeCSSVars,
  initialsFromFullName = __locals.initialsFromFullName,
  multiToggleFactory = __locals.multiToggleFactory,
  t = __locals.t,
  htmlWebpackPlugin = __locals.htmlWebpackPlugin;
    ; __append("<span class=\"nb-container\" new-nginbar>\n  <span class=\"nb-main ")
    ; __line = 2
    ; __append(escapeFn( $ctrl.nbMainClass ))
    ; __append("\">\n\n    ")
    ; __line = 4
    ; __append( $ctrl.backButton )
    ; __append("\n\n    ")
    ; __line = 6
    ; __append("\n    <a ")
    ; __line = 7
    ; __append( $ctrl.trackElementAs('$seLogo') )
    ; __append(" href=\"")
    ; __append(escapeFn( $ctrl.appHomeUrl ))
    ; __append("\" target=\"_top\" class=\"")
    ; __append(escapeFn( $ctrl.logoClass ))
    ; __append("\">")
    ; __append(escapeFn( $ctrl.appName ))
    ; __append("</a>\n    ")
    ; __line = 8
    ;  if ($ctrl.hasMobileNav) { 
    ; __append("\n      <button aria-label=\"")
    ; __line = 9
    ; __append(escapeFn( t('NAVIGATION.label')))
    ; __append("\" ")
    ; __append( $ctrl.trackElementAs('$mobileTrigger') )
    ; __append("class=\"nb-sportngin--mobile nb-sportngin--mobile-with-nav\">\n        ")
    ; __line = 10
    ; __append( $ctrl.mobileNavIcon )
    ; __append("\n        <span class=\"nb-mobile-nav__label\">")
    ; __line = 11
    ; __append(escapeFn( t('menu') ))
    ; __append("</span>\n      </button>\n    ")
    ; __line = 13
    ;  } else { 
    ; __append("\n      <a href=\"")
    ; __line = 14
    ; __append(escapeFn( $ctrl.config.urls.se ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( t('sportsengine_alt') ))
    ; __append("\" class=\"nb-sportngin--mobile\">")
    ; __append(escapeFn( t('sportsengine') ))
    ; __append("</a>\n    ")
    ; __line = 15
    ;  } 
    ; __append("\n\n    <span class=\"nb-search__container\" ")
    ; __line = 17
    ; __append( $ctrl.trackElementAs('searchContainer') )
    ; __append("></span>\n\n    ")
    ; __line = 19
    ;  if ($ctrl.profile) { 
    ; __append("\n      ")
    ; __line = 20
    ; __append( $ctrl.switcherButton )
    ; __append("\n    ")
    ; __line = 21
    ;  } 
    ; __append("\n\n    ")
    ; __line = 23
    ; __append("\n    ")
    ; __line = 24
    ;  if ($ctrl.profile) { 
    ; __append("\n      ")
    ; __line = 25
    ; __append( $ctrl.chatButton )
    ; __append("\n    ")
    ; __line = 26
    ;  } 
    ; __append("\n\n    ")
    ; __line = 28
    ; __append("\n    ")
    ; __line = 29
    ;  if ($ctrl.profile) { 
    ; __append("\n      ")
    ; __line = 30
    ; __append( $ctrl.messagesButton )
    ; __append("\n    ")
    ; __line = 31
    ;  } 
    ; __append("\n\n    ")
    ; __line = 33
    ; __append("\n    ")
    ; __line = 34
    ;  if ($ctrl.profile) { 
    ; __append("\n      ")
    ; __line = 35
    ; __append( $ctrl.notificationsButton )
    ; __append("\n    ")
    ; __line = 36
    ;  } 
    ; __append("\n\n    ")
    ; __line = 38
    ; __append("\n    ")
    ; __line = 39
    ;  if ($ctrl.profile) { 
    ; __append("\n      ")
    ; __line = 40
    ; __append( $ctrl.profileButton )
    ; __append("\n    ")
    ; __line = 41
    ;  } else { 
    ; __append("\n      ")
    ; __line = 42
    ; __append( $ctrl.signInButton )
    ; __append("\n    ")
    ; __line = 43
    ;  } 
    ; __append("\n  </span>\n</span>\n\n")
    ; __line = 47
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}; export default templateFn